import { locations, getLocationBySlug } from "../data/locations";
import locationPageContentModule from "../data/locationPageContent";
const locationPageContent = locationPageContentModule.locationPageContent || locationPageContentModule;

const SITE_URL = "https://revivefamilyclinic.com";
const CLINIC_PROFILE = {
  name: "Revive Family Clinic & X-Ray Diagnostics",
  email: "revivefamilyclinic281@gmail.com",
  telephone: "+91 86083 23094",
  address: {
    "@type": "PostalAddress",
    streetAddress: "MA Complex, NGO Nagar Main Rd, SSM Nagar, Alappakam",
    addressLocality: "New Perungalathur",
    addressRegion: "Tamil Nadu",
    postalCode: "600063",
    addressCountry: "IN",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "18:00",
      closes: "21:00",
    },
  ],
};
const SITE_NAME = CLINIC_PROFILE.name;
const DEFAULT_IMAGE = `${SITE_URL}/revive-logo.png`;
const INDEX_ROBOTS =
  "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";

const pageMeta = {
  "/": {
    title: "Family Clinic in New Perungalathur | Revive Clinic",
    description:
      "Consult a General Physician and Family Doctor at Revive Family Clinic in New Perungalathur. X-Ray services are coming soon.",
  },
  "/about": {
    title: "About Revive Family Clinic | New Perungalathur",
    description:
      "Learn about Revive Family Clinic in New Perungalathur and its patient-focused family medicine, general consultation and preventive healthcare.",
  },
  "/services": {
    title: "Medical Services in New Perungalathur | Revive Clinic",
    description:
      "Explore family medicine, general consultation, preventive healthcare and family-focused care at Revive Family Clinic in New Perungalathur.",
  },
  "/diagnostics": {
    title: "Digital X-Ray Coming Soon | Revive Family Clinic",
    description:
      "Digital X-Ray services are coming soon at Revive Family Clinic in New Perungalathur. Contact the clinic for launch updates.",
  },
  "/gallery": {
    title: "Clinic Gallery | Revive Family Clinic New Perungalathur",
    description:
      "View the facilities, diagnostic equipment, healthcare team and community activities of Revive Family Clinic in New Perungalathur.",
  },
  "/contact": {
    title: "Contact Revive Family Clinic | New Perungalathur",
    description:
      "Contact Revive Family Clinic in New Perungalathur for clinic information, appointments and enquiries about available medical services.",
  },
  "/privacy": {
    title: "Privacy Policy | Revive Family Clinic",
    description:
      "Read the privacy policy and terms for Revive Family Clinic & X-Ray Diagnostics.",
    robots: "noindex,follow",
  },
  "/admin": {
    title: "Clinic Administration | Revive Family Clinic",
    description: "Secure administration area for Revive Family Clinic.",
    robots: "noindex,nofollow",
    includeSchema: false,
  },
  "/admin/login": {
    title: "Admin Login | Revive Family Clinic",
    description: "Secure administration login for Revive Family Clinic.",
    robots: "noindex,nofollow",
    includeSchema: false,
  },
};

const normalizePathname = (pathname = "/") => {
  const pathOnly = pathname.split(/[?#]/, 1)[0] || "/";
  if (pathOnly === "/") return "/";
  return `/${pathOnly.replace(/^\/+|\/+$/g, "")}`;
};

const canonicalFor = (path) =>
  `${SITE_URL}${path === "/" ? "/" : `${path}/`}`;

const locationMeta = (serviceArea) => ({
  title:
    serviceArea.metaTitle ||
    `Family Clinic in ${serviceArea.name} | Revive Clinic`,
  description:
    serviceArea.metaDescription ||
    `Access Revive Family Clinic from ${serviceArea.name} for family medicine and general consultation. Digital X-Ray services are coming soon.`,
  serviceArea,
});

const locationFaqs = (serviceArea) => {
  if (serviceArea.slug === "nedunkundram") {
    return [
      {
        question:
          "Where is Revive Family Clinic & X-ray Diagnostics located?",
        answer:
          "Revive Family Clinic & X-ray Diagnostics is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu 600063.",
      },
      {
        question: "Is Revive Family Clinic located in New Perungalathur?",
        answer:
          "The clinic is located in the Nedunkundram area, near New Perungalathur, at SSM Nagar, Alappakam.",
      },
      {
        question: "Does Revive Family Clinic provide X-ray services?",
        answer:
          "X-Ray services are coming soon and are not currently operational. Contact the clinic for launch updates.",
      },
      {
        question: "How can I enquire about medical consultations?",
        answer:
          "You can contact the clinic using its verified phone number or website contact details to enquire about available consultations and appointment arrangements.",
      },
      {
        question: "Which areas are near Revive Family Clinic?",
        answer:
          "The clinic is located in Nedunkundram, near New Perungalathur, SSM Nagar, and Alappakam in Tamil Nadu.",
      },
      {
        question: "How can I find directions to the clinic?",
        answer:
          "You can use the clinic's Google Maps listing to find directions to MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu 600063.",
      },
    ];
  }

  if (locationPageContent[serviceArea.slug]?.faqs) {
    return locationPageContent[serviceArea.slug].faqs;
  }

  return [
    {
      question: `Is Revive Family Clinic accessible from ${serviceArea.name}?`,
      answer: serviceArea.travel,
    },
    {
      question: `What services are available near ${serviceArea.name}?`,
      answer:
        "Revive lists family medicine, general consultation, preventive healthcare, health check-ups and digital X-ray diagnostics. Contact the clinic to confirm availability.",
    },
    {
      question: `Can I book before travelling from ${serviceArea.name}?`,
      answer:
        "Yes. Call or WhatsApp the clinic to enquire about availability before your visit.",
    },
  ];
};

const getRouteMeta = (pathname) => {
  const path = normalizePathname(pathname);
  const locationMatch = path.match(/^\/family-clinic-in-(.+)$/);
  const serviceArea = locationMatch
    ? getLocationBySlug(locationMatch[1])
    : null;
  const configured = serviceArea ? locationMeta(serviceArea) : pageMeta[path];

  if (!configured) return null;

  return {
    path,
    canonical: canonicalFor(path),
    robots: INDEX_ROBOTS,
    includeSchema: true,
    ...configured,
  };
};

const getIndexableRoutePaths = () => [
  ...Object.keys(pageMeta).filter(
    (path) => !(pageMeta[path].robots || INDEX_ROBOTS).startsWith("noindex"),
  ),
  ...locations.map((location) => `/family-clinic-in-${location.slug}`),
];

const getStaticRoutePaths = () => [
  ...getIndexableRoutePaths(),
  "/privacy",
  "/admin",
  "/admin/login",
];

const getStructuredData = (meta) => {
  if (!meta || !meta.includeSchema) return null;

  const serviceArea = meta.serviceArea;
  const graph = [];

  if (meta.path === "/") {
    graph.push({
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: SITE_NAME,
    });
    graph.push({
      "@type": "MedicalClinic",
      "@id": `${SITE_URL}/#clinic`,
      name: CLINIC_PROFILE.name,
      url: `${SITE_URL}/`,
      logo: DEFAULT_IMAGE,
      image: DEFAULT_IMAGE,
      email: CLINIC_PROFILE.email,
      telephone: CLINIC_PROFILE.telephone,
      address: CLINIC_PROFILE.address,
      openingHoursSpecification: CLINIC_PROFILE.openingHoursSpecification,
      areaServed: { "@type": "Place", name: "New Perungalathur" },
    });
  }

  graph.push({
    "@type": "WebPage",
    "@id": `${meta.canonical}#webpage`,
    url: meta.canonical,
    name: meta.title,
    description: meta.description,
    isPartOf: { "@id": `${SITE_URL}/#website` },
    about: { "@id": `${SITE_URL}/#clinic` },
  });

  if (serviceArea) {
    const faqs = locationFaqs(serviceArea);
    graph.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: `${SITE_URL}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: `Family Clinic in ${serviceArea.name}`,
          item: meta.canonical,
        },
      ],
    });
    graph.push({
      "@type": "FAQPage",
      mainEntity: faqs.map(({ question, answer }) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: { "@type": "Answer", text: answer },
      })),
    });
  }

  return { "@context": "https://schema.org", "@graph": graph };
};

export {
  CLINIC_PROFILE,
  DEFAULT_IMAGE,
  INDEX_ROBOTS,
  SITE_NAME,
  SITE_URL,
  getIndexableRoutePaths,
  getRouteMeta,
  getStaticRoutePaths,
  getStructuredData,
  normalizePathname,
};

